import React from 'react';
import {
  Box,
  Typography,
  Collapse,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  CircularProgress
} from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Circle } from '@mui/icons-material';

const AddContactForm = ({
  Profileopen,
  formData,
  errors,
  handleProfileOpen,
  handleChangevalue,
  loading
}) => {
  return (
    <Box
      sx={{ boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.1)' }}
      style={{
        borderRadius: 6,
        borderBottomLeftRadius: Profileopen ? 6 : 6,
        borderBottomRightRadius: Profileopen ? 6 : 6,
        // marginLeft: 15,
        // marginRight: 15,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          cursor: 'pointer',
          backgroundColor: '#010f58',
          height: 40,
          padding: '0px 15px 0px 15px'
        }}
        style={{
          borderRadius: 6,
          borderBottomLeftRadius: Profileopen ? 0 : 6,
          borderBottomRightRadius: Profileopen ? 0 : 6
        }}
        onClick={handleProfileOpen}
      >
        <Typography
          variant="overline"
          sx={{ flex: 1, fontSize: 13, textTransform: 'capitalize', color: '#ffffff' }}
        >
          Contact Form
        </Typography>
        {Profileopen ? (
          <ExpandLess sx={{ color: '#ffffff' }} />
        ) : (
          <ExpandMore sx={{ color: '#ffffff' }} />
        )}
      </Box>

      {loading ? (
        <Box
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 248 }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box>
          <Collapse in={Profileopen}>
            <Box
              sx={{ flexWrap: 'nowrap', padding: '0px 15px 0px 15px' }}
              style={{
                borderBottomLeftRadius: Profileopen ? 6 : 0,
                borderBottomRightRadius: Profileopen ? 6 : 0,
                marginBottom: 20
              }}
            >
              <Grid container mt={2}>
                <Grid container spacing={2} mb={2}>
                  {/* Name  */}
                  <Grid item spacing={2} xs={12} sm={6}>
                    <TextField
                      label="Name"
                      name="name"
                      fullWidth
                      value={formData?.name}
                      onChange={handleChangevalue}
                      error={!!errors.name}
                      helperText={errors.name}
                      className="custom-textfield"
                    />
                  </Grid>

                  {/* Email */}
                  <Grid item spacing={2} xs={12} sm={6}>
                    <TextField
                      label="Email"
                      name="email"
                      fullWidth
                      value={formData?.email}
                      onChange={handleChangevalue}
                      error={!!errors.email}
                      helperText={errors.email}
                      className="custom-textfield"
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2} mb={2}>
                  {/* Contact Number */}
                  <Grid item spacing={2} xs={12} sm={6}>
                    <TextField
                      type="number"
                      label="Contact Number"
                      name="contactNumber"
                      fullWidth
                      value={formData?.contactNumber}
                      onChange={handleChangevalue}
                      error={!!errors.contactNumber}
                      helperText={errors.contactNumber}
                      className="custom-textfield"
                      onKeyDown={(e) => {
                        if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                          e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                        }
                      }}
                    />
                  </Grid>

                  {/* MC Number */}
                  <Grid item spacing={2} xs={12} sm={6}>
                    <TextField
                      type="number"
                      label="MC Number"
                      name="mcNumber"
                      fullWidth
                      value={formData?.mcNumber}
                      onChange={handleChangevalue}
                      error={!!errors.mcNumber}
                      helperText={errors.mcNumber}
                      className="custom-textfield"
                      onKeyDown={(e) => {
                        if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                          e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                        }
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2} mb={2}>
                  {/* FF Number */}
                  <Grid item spacing={2} xs={12} sm={6}>
                    <TextField
                      type="number"
                      label="FF Number"
                      name="ffNumber"
                      fullWidth
                      value={formData?.ffNumber}
                      onChange={handleChangevalue}
                      error={!!errors.ffNumber}
                      helperText={errors.ffNumber}
                      className="custom-textfield"
                      onKeyDown={(e) => {
                        if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                          e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                        }
                      }}
                    />
                  </Grid>

                  {/* Intrastate Number */}
                  <Grid item spacing={2} xs={12} sm={6}>
                    <TextField
                      type="number"
                      label="Intrastate Number"
                      name="intrastateNumber"
                      fullWidth
                      value={formData?.intrastateNumber}
                      onChange={handleChangevalue}
                      error={!!errors.intrastateNumber}
                      helperText={errors.intrastateNumber}
                      className="custom-textfield"
                      onKeyDown={(e) => {
                        if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                          e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                        }
                      }}
                    />
                  </Grid>
                </Grid>

                {/* Authority */}
                <Grid item xs={12}>
                  <TextField
                    label="Authority"
                    name="authority"
                    fullWidth
                    value={formData?.authority}
                    onChange={handleChangevalue}
                    error={!!errors.authority}
                    helperText={errors.authority}
                    className="custom-textfield"
                  />
                </Grid>
              </Grid>
            </Box>
          </Collapse>
        </Box>
      )}
    </Box>
  );
};

export default AddContactForm;
